import React from 'react';
import '../About/Ourdata.css';

const Ourdata = () => {
  return (
    <div className='container our-data'>
        <div className="grid-container">
            <div>
                <h1>17</h1>
                <p>years of experience</p>
            </div>

            <div>
                <h1>34</h1>
                <p>Team Members</p>
            </div>

            <div>
                <h1>1300</h1>
                <p>Customers served</p>
            </div>

            <div>
                <h1>60</h1>
                <p>Dishes</p>
            </div>

            <div>
                <h1>350+</h1>
                <p>Wines</p>
            </div>
        </div>

    </div>
  )
}

export default Ourdata